<template>
  <div class="shop-new">
    <div class="wrapper">
      <div class="top">
        <img :src="tukWord" @click="$router.go(-1)" />
        <span>SHOP</span>
        <div
          class="is-pulled-right is-uppercase link language"
          @click="openLanguageSelector"
        >
          {{ $store.state.language }}
        </div>
      </div>
      <div class="one-liner has-text-weight-bold">
        The easiest way to sell
        <i class="has-text-warning">everywhere</i>
      </div>
      <div class="subtitle">Everything you need for your online shop.</div>
      <div class="free">FREE</div>
      <div class="btn-wrapper">
        <a
          class="button is-fullwidth is-large is-rounded is-white"
          @click="gotoShopCreate"
        >
          Start Selling In Seconds
          <!-- <i class="fa fa-chevron-right" style="margin-left: 6px" /> -->
        </a>
      </div>

      <div class="bottom has-text-left has-text-grey">
        <div class="is-pulled-right" @click="comingSoon">Help</div>
        <div @click="seeShops">See Shops</div>
      </div>

      <!-- <div class="icons">
        <i class="fab fa-instagram" />&nbsp;
        <i class="fa fa-mobile-alt" />&nbsp;
        <i class="fab fa-line" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopNew",
  components: {},
  data() {
    return {
      tukWord: require("../../public/img/icons/transparent-dark-180x180.png"),
    };
  },
  mounted() {
    this.checkLangQuery();
    this.checkFCMQuery();
  },
  methods: {
    gotoShopCreate() {
      this.goto("/shop_create");
    },
    seeShops() {
      this.goto("/eat?r=cm");
    },
    comingSoon() {
      // var msg = "Hey y'all 🙌🏼<br>Any ideas? 💡";
      // this.warningToast(msg);
      var msg = `Opening live chat support&nbsp;<i class="fa fa-spinner fa-spin" />`;
      this.warningToast(msg);
      setTimeout(() => this.contactMerchantSupport(), 800);
    },
  },
};
</script>

<style scoped>
.shop-new {
  /* background-color: #fac002; */
  /* background-color: #f5d252; */
  /* background-color: ivory; */
  background-color: whitesmoke;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.wrapper {
  margin: auto;
  max-width: 700px;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  position: absolute;
  height: 150px;
  width: 150px;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.top {
  width: 100vw;
  max-width: 700px;
  text-align: left;
}
.top img {
  display: inline-block;
  height: 100px;
  /* margin-right: 10px; */
  margin-top: -10px;
  margin-left: 4px;
}
.top span {
  font-size: 28pt;
  font-weight: 550;
  color: #fac002;
  margin-top: 18px;
  margin-left: -10px;
  position: absolute;
}
.one-liner {
  padding: 20px;
  padding-top: 60px;
  font-size: 36px;
  font-weight: 900 !important;
}
.one-liner i {
  text-shadow: 1px 1px 2px black;
  /* text-shadow: 0 0 1px black; */
  /* text-transform: uppercase; */
}
.subtitle {
  /* margin-top: 20px; */
  padding: 12px;
  margin-bottom: 20px;
}
.btn-wrapper {
  padding: 16px;
  /* background-color: #fac002; */
}
.btn-wrapper .button {
  margin-top: 10px;
  /* background-color: #fac002; */
  background-color: var(--info);
  font-weight: 600;
  box-shadow: 3px 3px 9px grey;
}
.free {
  font-size: 40pt;
  font-weight: 900;
}
.bottom {
  padding: 12px;
  position: absolute;
  bottom: 0;
  width: 100vw;
  max-width: 700px;
  font-size: 1.4em;
}
.language {
  margin: 12px;
  font-weight: 500;
  color: grey;
}
.icons {
  animation: updown 2s ease infinite;
  position: absolute;
  /* bottom: -10px; */
  width: 100vw;
  animation-iteration-count: 1;
}
@keyframes updown {
  0% {
    transform: translateY(-300px);
  }

  50% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(-300px);
  }
}
</style>